export default __webpack_public_path__ + "static/media/UZ_flag.7f3710e6.png";